import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { primaryCTA, primaryCTATarget } from "../lib/config";

const SHOW_AFTER_PX = 480;

export const StickyMobileCTA = () => {
  const [visible, setVisible] = useState(false);
  const [nearForm, setNearForm] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  // Single scroll listener handles both visibility + form-proximity
  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > SHOW_AFTER_PX);
      const el = document.querySelector("#watch-list");
      if (!el) return setNearForm(false);
      const rect = el.getBoundingClientRect();
      setNearForm(rect.top < window.innerHeight && rect.bottom > 0);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, [location.pathname]);

  const handleClick = () => {
    const t = primaryCTATarget();
    if (t.startsWith("#")) {
      if (location.pathname !== "/") navigate("/" + t);
      else {
        const el = document.querySelector(t);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate(t);
    }
  };

  const shouldShow = visible && !nearForm && location.pathname !== "/app";

  return (
    <div
      data-testid="sticky-mobile-cta"
      className={`md:hidden fixed left-3 right-3 z-40 transition-all duration-300 ${
        shouldShow ? "opacity-100 translate-y-0 pointer-events-auto" : "opacity-0 translate-y-3 pointer-events-none"
      }`}
      style={{ bottom: "max(0.5rem, env(safe-area-inset-bottom))" }}
    >
      <button
        onClick={handleClick}
        className="pw-btn-primary w-full !text-sm !gap-2 shadow-[0_14px_40px_-14px_rgba(0,0,0,0.55)]"
        style={{ minHeight: "54px", paddingTop: "0", paddingBottom: "0" }}
      >
        {primaryCTA()} <ArrowRight className="w-3.5 h-3.5" />
      </button>
    </div>
  );
};

export default StickyMobileCTA;
